/* eslint-disable no-unused-vars */
import { ToastContainer } from 'react-toastify';
import { useState, useEffect } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { Loader } from './components';
import 'react-toastify/dist/ReactToastify.css';
import Router from './router/Router';

// api keys
const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
const mapApiJs = process.env.REACT_APP_GOOGLE_MAP_API_JS;

function loadAsyncScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src,
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

function App() {
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);

  const initMapScript = () => {
    // if script already loaded
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${googleMapApiKey}&libraries=places`;
    return loadAsyncScript(src);
  };

  useEffect(() => {
    initMapScript().finally(() => setGoogleMapsLoaded(true));

    // if (localStorage.getItem('token')) {
    //   initializeSocket();
    // }

    if (!localStorage.getItem('uuid')) {
      localStorage.setItem('uuid', uuidV4());
    }
  }, [localStorage.getItem('token')]);

  if (!googleMapsLoaded) return <Loader />;

  return (
    <>
      <Router />
      <ToastContainer hideProgressBar icon={false} />
    </>
  );
}

export default App;
